import React from 'react'
import { Link } from 'react-router-dom'
import '../scss/variables.scss'
import '../scss/reset.scss'
import './Community.scss'
import NavbarLogo from '../components/NavbarLogo/NavbarLogo'
import Footer from '../components/Footer/Footer'
import Button from '../components/Button/Button'
import Sidemenu from '../components/Sidemenu/Sidemenu'


function Progetto() {
    const titleButton = "ENTRA"

    return (
        <>
            <Sidemenu path1="/" name1="Home" path2="/chi-siamo" name2="Chi Siamo" path3="/progetto" name3="Il Progetto" path4="/supportaci" name4="Supportaci" />
            <NavbarLogo />
            <main id="community">
                <h1>Community</h1>
                <div className="communitySection">
                    <p>Questa sezione è ancora in fase di sviluppo, non appena 
                        la community aumenterà, saremo lieti di pubblicarla!</p>

                    <h5>Nel frattempo, se vuoi unisciti alle stanze!</h5>
                    <Link to="/stanze">
                        <Button title={titleButton} />
                    </Link> 

                </div>
            </main>
            <Footer />
        </>
    )
}

export default Progetto
